import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {CustomerSubjectForm} from "./CustomerSubjectForm";

export const CustomerSubjectCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <CustomerSubjectForm />
    </CustomCreate>
  );
};
